import { Store } from '@ngrx/store';
import { ApplicationState } from "../../../store/application-store";
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { WellKnownRoutePaths } from '../../../routing/well-known-route-paths';

@Component({
  selector: 'mojo-master-admin-mojo-widget',
  templateUrl: './master-admin-mojo-widget.component.html'
})
export class MasterAdminMojoWidgetComponent implements OnInit {
  constructor(
    protected store: Store<ApplicationState>,
    private router: Router) { }

  ngOnInit() {}

  onImgClick(event) {
    this.router.navigateByUrl(WellKnownRoutePaths.MojoDashboards.adminDashboard);
  }
}
